import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=45ca53d8&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=45ca53d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca53d8",
  null
  
)

export default component.exports